<template>
<portal to="modal-destination">
  <transition name="fade">
    <main class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__content">
        <HelperBtn @click.native="$emit('close')" size="sm" icon="close-icon" />
        <slot name="header" />
        <slot name="body" />
        <slot name="footer" />
      </div>
    </main>
  </transition>
</portal>
</template>

<script>
export default {
  name: 'ModalSlotted',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  &__overlay {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
  }
  &__content {
    z-index: 1;
    max-width: 90vw;
    min-width: 50vw;
    border-radius: 24px;
    background-color: white;
    overflow: hidden;
    position: relative;
    .helper-btn {
      position: absolute;
      right: 1rem;
      top: 1rem
    }
  }
}
</style>
